<script>
import isMobile from "./isMobile";
import Modal from "./modal.svelte";

export let height
export let width
export let fullSizeUrl
export let src
export let alt

const mobile = isMobile()

</script>

{#if fullSizeUrl}
    {#if mobile}
        <a href={fullSizeUrl}>
            <img {src} {alt} {height} {width} />
        </a>
    {:else}
        <Modal title={alt}>
            <img slot="trigger" {src} {alt} {height} {width} />
            <img class="max-width max-height" src={fullSizeUrl} {alt} />
            <a href={fullSizeUrl}>download image</a>
        </Modal>
    {/if}
{:else}
    <img {src} {alt} {height} {width} />
{/if}
